const ceoQueue = {
  waiting: "בתור",
  inProgress: "בעבודה",
  forReview: "לבדיקה",
  empty: "התור ריק",
  openInNotion: "פתח ב-Notion",
  queueTab: "תור",
  updatesTab: "עדכונים",
  noUpdates: "אין עדכונים חדשים",
  readyForReview: "מוכן לבדיקתך",
  questionsForYou: "Claude שואל אותך",
} as const;
export default ceoQueue;
